import WrapperStickySide, { selector as WrapperStickySideSelector } from './sticky-side/script';


export default {
	[WrapperStickySideSelector]: { Class: WrapperStickySide }
};
